import type { LocaleResources } from 'locales';
import React from 'react';
import { CommonModal } from 'src/components/shared/elements/modals/CommonModal';
import { toJSX } from 'src/utils/toJSXHelper';
import styles from './index.module.scss';

type Props = {
  pickupDeadline: string[];
  localeResources: LocaleResources;
  closeModal: () => void;
  onClick: () => void;
};

export const Presenter: React.FC<Props> = ({ localeResources, pickupDeadline, closeModal, onClick }) => (
  <CommonModal
    title={localeResources.products.chemicals.confirm}
    closeModal={closeModal}
    fixedElement={
      <div className={styles.wrap}>
        <div className={styles.bold}>{localeResources.featured.limitedSale.expirationConfirm}</div>
        <div className={styles.description}>
          {pickupDeadline.length >= 1 && (
            <p>
              {toJSX(
                localeResources.featured.limitedSale.expirationDate(
                  pickupDeadline[0] ?? '',
                  pickupDeadline[1] ?? '',
                  pickupDeadline[2] ?? '',
                  styles.strong
                )
              )}
            </p>
          )}
        </div>

        <button type="button" className={styles.button} onClick={onClick}>
          {localeResources.cart.addToCart}
        </button>
      </div>
    }
  />
);
